module.exports = __webpack_public_path__ + "assets/img/6.ec2fd792.png";